import { CardStatusDto } from '../api/dto/charging-card.dto'
import { CardStatus } from '../models/charging-card.model'

/** Function for mapping and transform DTO status to FE human readable status of charging card
 * @param - cardStatus as Type off ChargingCardDto.cardStatus
 * @return - type of CardStatus */
export const convertCardStatus = (cardStatus: CardStatusDto): CardStatus => {
  const status: Record<CardStatusDto, CardStatus> = {
    INACTIVE: CardStatus.inactive,
    ACTIVE: CardStatus.active,
    REJECTED: CardStatus.rejected,
    HAGER: CardStatus.inactive,
    EXPIRED: CardStatus.expired,
  }

  return status[cardStatus]
}
